module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAAAXNSR0IArs4c6QAAAH9JREFUOE/t1LEJQkEQhOHvYrUFtZbXh/ZhATagnQjWYvBOMTKzhpUDDQTlPF/6Np75WWbYTRHRY4kOV5ww0TbnFBHbJ2iDO3aYtXHk1Gj4Kh9B9SRLawfMscYNxz/qv7xAC6wGgepL/6YY66/n9Olo95jWrW+KXEAZpf5Bb+QB3wUoJ9YBEhsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sort.png
// module id = wEm3
// module chunks = 1 2